import React, {useEffect} from "react";
import SubTitle from "../../components/SubTitle";
import {useForm, FormProvider, SubmitHandler} from "react-hook-form";
import {useGetItemQuery, useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";
import {useLocation, useNavigate, useParams} from "react-router-dom";

import * as Params from "../../models/clientModels/interfaces/apiParams";
import * as statisticsCategoryApi from "../../api/statisticsApi/statisticsCategoryApi";

import * as statisticsItem2Api from "../../api/statisticsApi/statisticsItem2Api";
import {useQuery, useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import MWProgress from "../../components/MWProgress";
import {tokenSelector} from "../../Recoil/Atom/authState";

import StatisticsItem1Form from "./StatisticsItem1Form";
import {
  initializeStatistics2,
  initialStatisticsItem2ListParams,
  WOStatistics2,
} from "../../models/serverModels/workOrder/WOStatistics2";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";

const item2Schema = yup.object({
  itemName: yup.string().required("아이템명을 입력해주세요"),
  displayOrder: yup.number(),
});
const UpdateItem2 = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data, isLoading: isGetLoading} = useQuery(
    ["statistics2List", {...initialStatisticsItem2ListParams, token: tokenState}],
    () => statisticsItem2Api.getList({...initialStatisticsItem2ListParams, token: tokenState}),
    {
      select: (data: ResponseList<WOStatistics2>) =>
        data.items.find((item) => item.uid === parseInt(id!)),
    }
  );

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<WOStatistics2>,
    Params.Update<WOStatistics2>
  >({
    api: statisticsItem2Api.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/Statistics");
        queryClient.invalidateQueries("statisticsCategoryList");
      },
    },
  });

  const methods = useForm<WOStatistics2>({
    defaultValues: data || initializeStatistics2,
    resolver: yupResolver(item2Schema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(data);
  }, [data, reset]);

  const onSubmit: SubmitHandler<WOStatistics2> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeStatistics2, ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="항목 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <StatisticsItem1Form />
            <ConfirmButtonGroup link="/Statistics" cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateItem2;
